<div class="text-disc-renderer">
    <p class="link-icon">
        <span>
            <span class="link" >{{ text }}</span>
            @if(isMandatory){<span>*</span>}
        </span>
        @if(isIcon){<img [src]="ICONS.CHEVRON_RIGHT"/>}
    </p>
    @if(description){<p>{{ description }}</p>}
</div>